import React from 'react';
import CustomTableCreate from './CustomTableCreate';
import MyInputFile from '../fields/MyInputFile';

class DistributorCreate extends CustomTableCreate {

    customHandled(fields, fieldName, fieldList) {
        console.log('customHandled');
        console.log(fieldName);

        if (fieldName === 'logo') {
            fieldList.push(<MyInputFile source={fieldName} label={'Logo'} folder={'distributor-logo'} />);
            return true;
        } else if (fieldName === 'qrCode') {
            fieldList.push(<MyInputFile source={fieldName} label={'QR Code'} folder={'distributor-qr-code'} />);
            return true;
        } else if (fieldName === 'clicksEmail' || fieldName === 'clicksWechat') {
            return true;
        }
        return false;
    }
}

export default DistributorCreate;
